import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import { ChangePasswordModel } from '../../models/auth.model';
import { ServerResponse } from '../../models/server-response.model';
import { ModalSuccessService } from '../modal-success/modal-success.service';

@Injectable({
  providedIn: 'root',
})
export class ChangePasswordService {
  private changePassword = environment.CHANGE_PASSWORD;

  constructor(
    private readonly http: HttpClient,
    private readonly modalSuccess: ModalSuccessService
  ) {}

  public changeUserPassword(
    password: ChangePasswordModel
  ): Observable<ServerResponse> {
    this.modalSuccess.modal.next(true);
    this.modalSuccess.button.next('Cerrar');
    return this.http.patch<ServerResponse>(this.changePassword, password);
  }
}
